import { Grid, List, ListItem, ListItemAvatar, ListItemText, Avatar } from "@mui/material";

function News() {

    return(
        <Grid
            container
            height="100%"
            direction="column">
            
            <Grid>
                <List>
                    <ListItem>
                        <ListItemAvatar>
                            {/* 이미지 넣는 방식 */}
                            <Avatar variant="square">경주</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary="새로운 센터 개방"
                            secondary="21.12.25"
                         />
                    </ListItem>
                </List>
            </Grid>
        </Grid>
    )
}

export default News;